// Re-renders the parts of the CS list that change with filters or edits (header line, tab counts,
// metrics, toolbar, table) from the server, without a page navigation.
const REGIONS = [".arf-sub", ".cs-subtabs", "[data-cs-metrics]", "[data-cs-list-form]", ".cs-gridbox", ".cs-focusbox", ".cs-campaignsbox"];

let pending: AbortController | null = null;

function listUrl(url: string): URL {
  const target = new URL(url, window.location.origin);
  target.searchParams.delete("edit");
  return target;
}

export async function refreshList(url: string = window.location.href, push = false): Promise<boolean> {
  if (!document.querySelector("[data-cs-list]")) return false;

  const target = listUrl(url);
  pending?.abort();
  pending = new AbortController();
  let html: string;
  try {
    const response = await fetch(target.toString(), { headers: { Accept: "text/html" }, signal: pending.signal });
    if (!response.ok) throw new Error(String(response.status));
    html = await response.text();
  } catch (_e) {
    return false;
  }

  const fresh = new DOMParser().parseFromString(html, "text/html");
  const focused = document.activeElement as HTMLElement | null;
  const focusId = focused?.id;
  REGIONS.forEach((selector) => {
    const current = document.querySelector(selector);
    const next = fresh.querySelector(selector);
    if (current && next) current.replaceWith(document.importNode(next, true));
  });
  if (focusId) document.getElementById(focusId)?.focus();

  const shown = new URL(target.toString());
  shown.searchParams.delete("panel");
  shown.searchParams.delete("fsec[]");
  history[push ? "pushState" : "replaceState"](history.state, "", shown.toString());
  (window as any).mountLogos?.();
  document.dispatchEvent(new CustomEvent("cs-list:refreshed"));
  return true;
}
